module.exports = __webpack_public_path__ + "static/media/unsubscribed.6865c5e0.svg";